/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListTargets200ResponseItemsInner } from './ListTargets200ResponseItemsInner';
import {
    ListTargets200ResponseItemsInnerFromJSON,
    ListTargets200ResponseItemsInnerFromJSONTyped,
    ListTargets200ResponseItemsInnerToJSON,
    ListTargets200ResponseItemsInnerToJSONTyped,
} from './ListTargets200ResponseItemsInner';

/**
 * 
 * @export
 * @interface ListTargets200Response
 */
export interface ListTargets200Response {
    /**
     * 
     * @type {Array<ListTargets200ResponseItemsInner>}
     * @memberof ListTargets200Response
     */
    items?: Array<ListTargets200ResponseItemsInner>;
}

/**
 * Check if a given object implements the ListTargets200Response interface.
 */
export function instanceOfListTargets200Response(value: object): value is ListTargets200Response {
    return true;
}

export function ListTargets200ResponseFromJSON(json: any): ListTargets200Response {
    return ListTargets200ResponseFromJSONTyped(json, false);
}

export function ListTargets200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTargets200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ListTargets200ResponseItemsInnerFromJSON)),
    };
}

export function ListTargets200ResponseToJSON(json: any): ListTargets200Response {
    return ListTargets200ResponseToJSONTyped(json, false);
}

export function ListTargets200ResponseToJSONTyped(value?: ListTargets200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ListTargets200ResponseItemsInnerToJSON)),
    };
}

